"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const statements_1 = require("../types/statements");
__export(require("./date"));
exports.CONSTANTS = {
    SALES_REP_ROLE_NAME: 'Zunta Sales Rep.',
};
exports.ZUNTA_ADMIN_ID = 1;
exports.ZUNTA_DATA_ENTRY_ID = 3;
var COLLECTION_FLOW_STATUS;
(function (COLLECTION_FLOW_STATUS) {
    COLLECTION_FLOW_STATUS["UPDATING"] = "UPDATING";
    COLLECTION_FLOW_STATUS["REPEAT"] = "REPEAT";
    COLLECTION_FLOW_STATUS["AVAILABLE"] = "AVAILABLE";
})(COLLECTION_FLOW_STATUS = exports.COLLECTION_FLOW_STATUS || (exports.COLLECTION_FLOW_STATUS = {}));
;
exports.STATUSES_LABEL_MAP = {
    [statements_1.EStatementStatuses.NEEDS_REVIEW]: 'Needs Review',
    [statements_1.EStatementStatuses.NEEDS_FIX]: 'Needs Fix',
    [statements_1.EStatementStatuses.READY_TO_MAIL]: 'Ready To Mail',
    [statements_1.EStatementStatuses.READY_TO_PRINT]: 'Ready To Print',
    [statements_1.EStatementStatuses.DO_NOT_BILL]: 'Do Not Bill this Month',
    [statements_1.EStatementStatuses.IN_PROCESS]: 'In Process',
    [statements_1.EStatementStatuses.IN_TRANSIT]: 'In Transit',
    [statements_1.EStatementStatuses.IN_LOCALAREA]: 'In Local area',
    [statements_1.EStatementStatuses.DELIVERED]: 'Delivered',
    [statements_1.EStatementStatuses.RETURNED]: 'Returned',
    [statements_1.EStatementStatuses.REROUTED]: 'Rerouted',
    [statements_1.EStatementStatuses.PROCESSED_FOR_DELIVERY]: 'Processed for delivery',
    [statements_1.EStatementStatuses.PRINTED_LOCALLY]: 'Printed Locally',
    [statements_1.EStatementStatuses.EMAILED]: 'Sent by Email',
    [statements_1.EStatementStatuses.EMAIL_RETURNED]: 'Email Returned',
    [statements_1.ELetterStatus.SKIP]: 'Do not send',
    [statements_1.EStatementStatuses.DO_NOT_BILL_ZERO]: 'Zero Balance',
    [statements_1.EStatementStatuses.DO_NOT_BILL_CONTROL]: 'Low Balance',
    [statements_1.EStatementStatuses.DO_NOT_BILL_NEGATIVE]: 'Negative Balance',
    [statements_1.EStatementStatuses.DO_NOT_BILL_PERMANENTLY]: 'Permanently Excluded',
    [statements_1.EStatementStatuses.DO_NOT_BILL_RETURNED]: 'Returned - Do Not Bill',
    [statements_1.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED]: 'Email Returned - Do Not Bill',
};
var MAILING_TYPE;
(function (MAILING_TYPE) {
    MAILING_TYPE["Letter"] = "letter";
    MAILING_TYPE["Statement"] = "statement";
})(MAILING_TYPE = exports.MAILING_TYPE || (exports.MAILING_TYPE = {}));
;
var EManualReportTypes;
(function (EManualReportTypes) {
    EManualReportTypes["resident"] = "resident";
    EManualReportTypes["contact"] = "contact";
    EManualReportTypes["transaction"] = "transaction";
    EManualReportTypes["deposit"] = "deposit";
})(EManualReportTypes = exports.EManualReportTypes || (exports.EManualReportTypes = {}));
exports.REPORT_PREFIXES = {
    [EManualReportTypes.resident]: 'Resident_List_Report',
    [EManualReportTypes.contact]: 'Resident_Listing',
    [EManualReportTypes.transaction]: 'TransactionReportbyEffectiveDate',
};
var EActivityMessages;
(function (EActivityMessages) {
    EActivityMessages["MailStatements"] = "Mailing Statements In Process";
    EActivityMessages["FailedMailStatementsOnBatchFail"] = "Mail Statements failed due to failed batch generation";
    EActivityMessages["NoReadyToMailForMailing"] = "Issue with finding ready to mail statements";
})(EActivityMessages = exports.EActivityMessages || (exports.EActivityMessages = {}));
exports.MANUAL_PCC_FILES_EXPIRE_MS = 3 * 60 * 60 * 1000;
